import React from 'react';
import {Button, Card, Col, Container, Row} from 'react-bootstrap';
import FabrizzioVideo from '../assets/img/fabrizzio-demo.mp4'; // Reemplaza con una imagen representativa

const InformacionFabrizzio = () => {
    return (
        <section style={{paddingTop: "120px"}}>
            <Container>
                <Row className="text-center mb-4">
                    <Col>
                        <h1 style={{fontWeight: 'bold', color: '#bc2b6c'}}>¡Hola, soy Fabrizzio!</h1>
                        <p style={{fontSize: '1.2rem', color: '#575a77'}}>
                            Tu asistente virtual de <strong>izzi</strong>, aquí para ayudarte a gestionar órdenes de
                            compra y guiarte en el proceso de ventas.
                        </p>
                    </Col>
                </Row>
                <Row className="align-items-center g-0">
                    <Col md={6} className="d-flex justify-content-center">
                        <video
                            src={FabrizzioVideo}
                            autoPlay
                            loop
                            muted
                            className="video-fluid"
                        />
                    </Col>
                    <Col md={6}>
                        <Card style={{border: 'none', backgroundColor: '#fff', padding: '1.5rem'}}>
                            <Card.Body>
                                <Card.Title style={{color: '#18191f', fontWeight: 'bold', marginBottom: '1rem'}}>
                                    ¿Qué puedo hacer por ti?
                                </Card.Title>
                                <Card.Text style={{fontSize: '1rem', color: '#575a77', lineHeight: '1.6'}}>
                                    Como tu asistente, me especializo en:
                                    <ul style={{paddingLeft: '1.2rem', marginTop: '1rem'}}>
                                        <li>Guiarte paso a paso en el proceso de ventas, desde capturar datos hasta
                                            cerrar acuerdos.
                                        </li>
                                        <li>Ayudarte a seleccionar productos que cumplan con los requisitos del
                                            cliente.
                                        </li>
                                        <li>Detectar y corregir errores en los datos ingresados para asegurar la mejor
                                            experiencia.
                                        </li>
                                        <li>Responder tus preguntas de forma clara, profesional y concisa.</li>
                                    </ul>
                                </Card.Text>
                                <Button
                                    variant="primary"
                                    style={{backgroundColor: '#bc2b6c', borderColor: '#bc2b6c', marginTop: '1rem'}}
                                >
                                    ¡Comienza ahora!
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row className="mt-5">
                    <Col>
                        <h2 className="text-center" style={{color: '#18191f'}}>
                            ¿Por qué elegir a Fabrizzio?
                        </h2>
                        <p style={{fontSize: '1rem', textAlign: 'center', color: '#575a77', lineHeight: '1.6'}}>
                            Priorizo la satisfacción del cliente y me aseguro de que cada paso sea sencillo y eficiente.
                            Soy claro, profesional y siempre estoy disponible para ayudarte a lograr tus objetivos de
                            ventas.
                        </p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default InformacionFabrizzio;
